import { tag } from 'services/graphql/fragments/Fragments';
import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import { gql } from 'urql';

const FetchIncentiveDetails = gql`
  query incentiveDetails($input: IncentiveDetailsInput!) {
    incentiveDetails(input: $input) {
      ... on IncentiveDetailsError {
        code
        title
        message
      }
      ... on IncentiveDetailsSuccess {
        __typename
        id
        heroImage {
          ... on URLType {
            url
          }
        }
        centerImage {
          ... on URLType {
            url
          }
        }
        headerTag {
          ...tag
        }
        incentiveTitle
        incentiveSubTitle
        alert {
          __typename
          alertType
          title
          body
          icon
          clickAnalytics {
            ...analytics
          }
        }
        intervalsHeading {
          __typename
          text
          tag {
            ...tag
          }
        }
        intervals {
          __typename
          id
          state
          asset {
            ... on CopyValue {
              text
            }
            ... on IconStyleDictionary {
              id
              fallbackURL
              iconKey
            }
          }
          caption
        }
        stepsHeading {
          __typename
          text
          tag {
            ...tag
          }
        }
        steps {
          __typename
          id
          state
          icon
          descriptionText
          annotationText
        }
        termsHtml
        termsLinkAction {
          ... on OpenPdfUrlAction {
            id
            url
            analyticsEvent {
              ...analytics
            }
          }
        }
        ctaButton {
          __typename
          id
          buttonStyle
          buttonText
          buttonOnClick {
            ... on RouteNavigationAction {
              __typename
              route
              analyticsEvent {
                ...analytics
              }
            }
          }
        }
      }
    }
  }
  ${tag}
  ${AnalyticsFragment}
`;

export default FetchIncentiveDetails;
